import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=064e424c&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064e424c')) {
      api.createRecord('064e424c', component.options)
    } else {
      api.reload('064e424c', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=064e424c&", function () {
      api.rerender('064e424c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/PieChart.vue"
export default component.exports